import type { IUser } from "@/api";
import { useQueryClient } from "@tanstack/react-query";

import { UserRegistrationStatus } from "./UserRegistrationStatus";

export function InvitationStatusCell({ user }: { user: IUser }) {
    const queryClient = useQueryClient();
    return (
        <UserRegistrationStatus
            invitationId={user.invitation_id ?? null}
            createdAt={user.created_at}
            prefetched={
                user.invitation_id
                    ? {
                          acceptedAt: user.invitation_accepted_at ?? null,
                          lastSentAt: user.invitation_last_sent_at ?? "",
                      }
                    : undefined
            }
            onResendSuccess={() =>
                queryClient.invalidateQueries({ queryKey: ["admin-users"] })
            }
            showIcon={false}
        />
    );
}
